import { ProtocolContentData } from "../../protocol";
export default class BeginOrEndOfSeaPassage extends ProtocolContentData {
    bospEosp;
    distanceSinceDepartureBosp;
    freeText;
    constructor(bospEosp, distanceSinceDepartureBosp, freeText) {
        super();
        this.bospEosp = bospEosp;
        this.distanceSinceDepartureBosp = distanceSinceDepartureBosp;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=BeginOrEndOfSeaPassage.js.map